import { useState } from "react";
import { EuiFilterButton, EuiFilterGroup, EuiSelectable, EuiCheckbox } from "@elastic/eui";
import { getSelectedOnTop } from "utils";

import Popover from "components/Popover/Popover";
import { useCompareDropdownStyles } from "../../../Performance/Activity_V2/Compare/CompareDropdownStyles";

export const SelectDropdown = ({
  selectedItem,
  options,
  setOptions,
  setSelectedItem,
  onChange,
  width = 300,
  isLoading,
  searchable = true,
  isPanelWidth = false,
  hideCheckbox = false,
}: any) => {
  const classes = useCompareDropdownStyles();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const onButtonClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const closePopover = () => {
    setIsPopoverOpen(false);
  };

  const button = (
    <EuiFilterButton
      isLoading={isLoading}
      iconType="arrowDown"
      badgeColor="accent"
      css={{
        minWidth: width < 300 ? width : "550px",
        width: width < 300 ? width : "100%",
        maxWidth: width < 300 ? width : "750px",
      }}

      onClick={onButtonClick}
      isSelected={isPopoverOpen}>
      {selectedItem}
    </EuiFilterButton>
  );

  return (
    <>
      <EuiFilterGroup style={{ width: "100%" }}>
        <Popover
          button={button}
          isOpen={isPopoverOpen}
          onClose={closePopover}
          panelPaddingSize="none"
          panelStyle={
            isPanelWidth
              ? {
                  minWidth: width < 300 ? width : "550px",
                  width: "100%",
                  maxWidth: width < 300 ? width : "590px",
                }
              : {}
          }
          style={{
            minWidth: width < 300 ? width : "550px",
            width: "100%",
            maxWidth: width < 300 ? width : "700px",
          }}
          children={
            <div>
              <EuiSelectable
                allowExclusions={false}
                singleSelection
                listProps={{ showIcons: false }}
                searchProps={{
                  placeholder: "",
                  compressed: false,
                  css: {
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    borderBottom: ".6px solid var(--border-color)",
                    boxShadow: "none",
                    backgroundColor: "var(--card-background)",
                  },
                }}
                aria-label="Data list"
                searchable={searchable}
                renderOption={(option) => {
                  const isChecked = option.checked === "on";
                  return hideCheckbox ? (
                    <span>{option.label}</span>
                  ) : (
                    <div className={classes.optionRow}>
                      <EuiCheckbox
                        id={`checkbox_${option.label}`}
                        checked={isChecked}
                        onChange={() => {}}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOptions(
                            options.map((i, index) => ({
                              ...i,
                              checked: i.label === option.label ? "on" : "",
                            }))
                          );
                          setSelectedItem(option.label);
                          onButtonClick();
                        }}
                        label={
                          <div className={classes.checkboxLabel}>
                            <span>{option.label}</span>
                          </div>
                        }
                      />
                    </div>
                  );
                }}
                options={searchable ? getSelectedOnTop(options, selectedItem) : options}
                onChange={(newOptions) => {
                  onChange();
                }}
                loadingMessage="Loading data"
                emptyMessage={"No data"}
                noMatchesMessage="No data found">
                {(list, search) => (
                  <div style={{ width }}>
                    {search}
                    {list}
                  </div>
                )}
              </EuiSelectable>
            </div>
          }
        />
      </EuiFilterGroup>
    </>
  );
};
